module.exports = __webpack_public_path__ + "static/media/Abbey-Knoll-Architectural-Committee-Requirements-AKHOA-1987.38c414b2.pdf";